export default __webpack_public_path__ + "static/media/mmrda.575cfaaf.png";